import { store } from '_/vuex/store';

export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        /**
         * The desired height of the resized image
         *
         * @type  {Object}
         */
        fileUrl: {
            required: true,
            type: String,
        },

        /**
         * A watched parameter used to reinstantiate the plugin as needed
         *
         * @type  {Object}
         */
        refresh: {
            type: Boolean,
        },

        /**
         * The focal point X coordinate
         *
         * @type  {Object}
         */
        x: {
            type: Number,
        },

        /**
         * The focal point Y coordinate
         *
         * @type  {Object}
         */
        y: {
            type: Number,
        },
    },

    data() {
        return {
            /**
             * The focal point X coordinate
             *
             * @type  {Object}
             */
            imageWidth: null,

            /**
             * The focal point Y coordinate
             *
             * @type  {Object}
             */
            imageHeight: null,
        };
    },

    computed: {},

    methods: {
        initializeDraggable() {
            const self = this;

            const $draggable = $(this.$el).find('.focal-point-cursor');

            const $containment = $(this.$el).find('.constraint-frame');

            const $image = $($containment).find('img');

            if ($draggable.hasClass('ui-draggable')) {
                $draggable.draggable('destroy');
            }

            $draggable.draggable({
                containment: $containment,
                scroll: false,
                stop(event, ui) {
                    self.setFocalPoint({
                        x: ui.position.left,
                        y: ui.position.top,
                    });
                },
            });

            $($image).click((event) => {
                $($draggable).css({
                    left: event.offsetX,
                    top: event.offsetY,
                });

                self.setFocalPoint({
                    x: event.offsetX,
                    y: event.offsetY,
                });
            });
        },

        /**
         * Gets image width and height on image load
         *
         * @return  {void}
         */
        onImgLoaded() {
            const $image = $(this.$el).find('.constraint-frame img');

            this.imageWidth = $($image).width();
            this.imageHeight = $($image).height();

            this.setFocalPointInitialLocation();
        },

        /**
         * Sets the focal point initial location
         *
         * @return {void}
         */
        setFocalPointInitialLocation() {
            const x = Math.floor((this.x * this.imageWidth) / 100);
            const y = Math.floor((this.y * this.imageHeight) / 100);

            const $draggable = $(this.$el).find('.focal-point-cursor');

            $($draggable).css({
                left: x,
                top: y,
            });
        },

        /**
         * Fired upon receiving the onImgAreaSelect event from the ImgAreaSelect module
         *
         * @param   {integer}  options.id
         * @param   {integer}  options.X
         * @param   {integer}  options.Y
         * @param   {integer}  options.width
         * @return  {void}
         */
        setFocalPoint({ x, y }) {
            const xPercentage = Math.floor((x / this.imageWidth) * 100);
            const yPercentage = Math.floor((y / this.imageHeight) * 100);

            this.$emit('change', {
                x: xPercentage,
                y: yPercentage,
            });
        },
    },

    mounted: function () {
        this.$nextTick(function () {
            this.initializeDraggable();
        });
    },
};
